import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';
import { useSession } from 'frontend/js/modules/infra/session';
import { useToggle } from 'frontend/js/modules/infra/small-tools/use-toggle';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { useFeatureFlags } from 'frontend/js/modules/infra/feature-flags';
import { useEngageTable } from './table/use-table';
import { EngageCampaignListView } from './list-view';
import { getUrlPrefixFromView, useNavigate } from '../../../../infra/routing';
import { BannerType } from '../../banners';
import { useSetupEngageBanner } from '../../banners/hooks/use-setup-engage-banner';
import { EngageTracker } from '../../tracking';
import { ENGAGE_CAMPAIGNS_LIST_VIEWED } from '../../tracking/events';
import { useEngageTableV1 } from './filters/filter-v1/use-table';
export var EngageCampaignListContainer = function () {
    var _a, _b;
    var engageNewFilters = useFeatureFlags().engageNewFilters;
    var session = useSession().data;
    var _c = engageNewFilters
        ? useEngageTable()
        : useEngageTableV1(), table = _c.table, isLoading = _c.isLoading, emptyTableState = _c.emptyTableState, onRowClick = _c.onRowClick, pagination = _c.pagination, count = _c.count, filters = _c.filters, sort = _c.sort;
    var urlPrefix = getUrlPrefixFromView(session.view);
    var navigate = useNavigate();
    var isFiltersOpen = useToggle();
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    useSetupEngageBanner({
        bannerType: BannerType.AutomatedCampaign,
        onPrimaryClick: function () { return navigate("".concat(urlPrefix, "/engagement/automated")); },
    });
    var hasActiveFilter = sort.sortName !== 'createdAtDesc' ||
        ((_a = filters.filterState.statusFilter) === null || _a === void 0 ? void 0 : _a.length) ||
        ((_b = filters.filterState.typeFilter) === null || _b === void 0 ? void 0 : _b.length) ||
        filters.filterState.creatorFilter.length;
    useEffect(function () {
        if (!isLoading && count !== undefined) {
            EngageTracker.getInstance().track(ENGAGE_CAMPAIGNS_LIST_VIEWED, {
                totalCampaigns: count,
                pageNumber: pagination.pagination.pageIndex + 1,
                pageSize: pagination.pagination.pageSize,
                hasActiveFilters: !!hasActiveFilter,
            });
        }
    }, [isLoading, count, pagination.pagination.pageIndex, pagination.pagination.pageSize, hasActiveFilter]);
    return (_jsx(EngageCampaignListView, { table: table, isLoading: isLoading, emptyTableState: emptyTableState, onRowClick: onRowClick, count: count, pagination: pagination, onOpenFilters: isFiltersOpen.setOn, isFiltersOpen: isFiltersOpen.isOn, onCloseFilters: isFiltersOpen.setOff, filters: filters, sort: sort, hasActiveFilter: !!hasActiveFilter, mobileView: isMobileOrSmaller, engageNewFiltersEnabled: engageNewFilters }));
};
